import { render, staticRenderFns } from "./vendor_zone_management.vue?vue&type=template&id=1c1d5d7c"
import script from "./vendor_zone_management.vue?vue&type=script&lang=js"
export * from "./vendor_zone_management.vue?vue&type=script&lang=js"
import style0 from "./vendor_zone_management.vue?vue&type=style&index=0&id=1c1d5d7c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports